"use client"

import { useState } from "react"
import {
  MoonIcon, ExpandIcon, ShrinkIcon, ShoppingCart, SunIcon, Contact2Icon, BoxesIcon,
  Shirt, Circle, Activity, Dumbbell, Waves, Bike, Flag, Trophy
} from 'lucide-react'
import { Button } from "../../components/ui/button"
import { Iframe3DUI } from "./iframe-3d-ui"
import { BudgetModal } from "./iframe-budget";
import { SportsLoading } from "./sports-loading";
import { CustomizationModal } from "./customization-modal";
import UniformSimulator from "./uniform-simulator";
import FormIframe from "../simulador/form/index";
import UniformForm from "../simulador/form2/uniform-form";
import JerseyBirdPage from '../../components/JerseyBirdPage';
import '../../styles/jerseybird.css';

const categoryData = [
  { id: "futebol", icon: Circle, color: "145" },
  { id: "basquete", icon: Activity, color: "30" },
  { id: "volei", icon: Waves, color: "200" },
  { id: "corrida", icon: Flag, color: "320" },
  { id: "ciclismo", icon: Bike, color: "85" },
  { id: "academia", icon: Dumbbell, color: "260" },
  { id: "esports", icon: Trophy, color: "280" },
  { id: "personalizado", icon: Shirt, color: "0" },
] as const

type CategoryId = typeof categoryData[number]["id"]

export function IframeViewer() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<CategoryId | null>(null)

  function openModalBudget() {
    setIsModalOpen(true);
    (window as { [key: string]: any })["setupCamera"]();

    setTimeout(() => {
      // Agora, pegue o canvas como imagem:
      const dataURL = (window as { [key: string]: any }).renderer.domElement.toDataURL('image/png');

      (window as { [key: string]: any }).addKit(
        $("#kit-iframe-title").text(),
        dataURL,
        (window as { [key: string]: any }).fabricCanvas.toDataURL("image/webp"),
        (window as { [key: string]: any }).fabricCanvas.toSVG(),
        [
          { id: "1", name: "Camisa", selected: true, quantity: 5, price: 1 },
          { id: "2", name: "Calção", selected: true, quantity: 6, price: 2 },
          { id: "3", name: "Meias", selected: true, quantity: 7, price: 3 },
        ]
      )

      const sellers = (window as { [key: string]: any }).sellers;

      for (var i = 0; i < sellers.length; i++) {

        const elem = "<div data-phone='" + sellers[i].phone + "'>" +
          "<div class='seller' data-phone='" + sellers[i].phone + "' style='background-image: url(https://nfghuenhuaecfyccyaib.supabase.co/storage/v1/object/public/images/" + sellers[i].thumb + ")'></div>" +
          "<span>" + sellers[i].name + "</span>" +
          "<button class='send-message-iframe'>ENVIAR ORÇAMENTO</button>" +
          "</div>";

        $("#list-sellers").append(elem);
      }
    }, 100);
  }

  const getCategoryInfo = (id: CategoryId) => {
    const data = categoryData.find((c) => c.id === id)!
    return {
      ...data,
      name: "",
      description: "",
    }
  }

  return (
    <div>

      <div className="hidden pointer-events-none opacity-0">
        <CustomizationModal
          isOpen={true}
          onClose={() => setIsModalOpen(false)}
          category={getCategoryInfo(selectedCategory as any)}
        />
      </div>

      <div className="z-[10000000000000000000000000] absolute top-0 left-0 w-full h-full fixed">
        <UniformSimulator></UniformSimulator>
      </div>

      {/**<div className="hidden">
        <Iframe3DUI />
      </div> */}

      {/**<div className="z-[10000000000000000000000000000000] relative">
        <BudgetModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      </div> */}

      <div className="z-[1000000000000000000] fixed top-0" id="loadingNew">
        <SportsLoading message="Carregando ferramentas de customização 3D..." />
      </div>

      <div className="fixed top-2 right-2 flex z-[1] flex-col md:flex-row">
        {/**<Button id="btn-budget" onClick={() => openModalBudget()} className="hidden bg-[orange] text-primary-foreground hover:bg-primary/90 m-1">
          <ShoppingCart></ShoppingCart>

          {!(window as any).isMobile ? (<span>ORÇAMENTO</span>) : null}
        </Button> */}

        {/**<Button id="theme-iframe" className="m-1 bg-secondary text-primary hover:bg-primary hover:text-secondary">
          <SunIcon id="theme-iframe-sun"></SunIcon>
          <MoonIcon id="theme-iframe-moon" className="hidden"></MoonIcon>
        </Button> */}

        {/**<Button id="full-iframe" className="m-1 bg-secondary text-primary hover:bg-primary hover:text-secondary">
          <ExpandIcon id="full-expand"></ExpandIcon>
          <ShrinkIcon id="full-shrink" className="hidden"></ShrinkIcon>
        </Button> */}
      </div>

      <div className="z-[100000000000000000000000000] absolute top-0 left-0 w-full h-full fixed !text-primary hidden" id="form-iframe2" >
        <UniformForm></UniformForm>
      </div>

      <div className="hidden text-primary h-full absolute top-0 left-0 z-[10000000000000000000000]" id="landing-iframe2">
        <div className="z-[1000000000000000000] overflow-y-auto max-w-full h-full fixed">
          <JerseyBirdPage initialConfig={null} onConfigChange={null} />
        </div>
      </div>
    </div>
  );
}